import dynamic from "next/dynamic";
import { Builder } from "@builder.io/react";
import { toolkitColors } from "@/utils/constants";

const LogoBanner = dynamic(async () => {
  return (await import("./LogoBanner")).default;
});

Builder.registerComponent(LogoBanner, {
  name: "Logo Banner",
  inputs: [
    {
      name: "backgroundColor",
      type: "string",
      defaultValue: "Oat",
      enum: toolkitColors,
      helperText: "Background color for the banner",
    },
    {
      name: "logos",
      type: "list",
      helperText: "Click on the above button to add a logo",
      subFields: [
        {
          name: "image",
          type: "file",
          allowedFileTypes: ["png", "svg"],
          helperText:
            "You can upload a file type that is either PNG or SVG",
          required: true,
        },
        {
          name: "logoLink",
          type: "url",
          helperText: "Logo specific URL",
        },
        {
          name: "logoAltText",
          type: "string",
          helperText: "alt text",
        },
      ],
    },
    {
      name: "wrapperClass",
      type: "string",
      helperText:
        "Custom wrapper classname added by developers",
    },
    {
      name: "logoClass",
      type: "string",
      helperText:
        "Custom wrapper classname added by developers",
    },   
    {
      name: "slidesToShow",
      type: "number",
      helperText:
        "Add number of logos to be shown",
    },   
  ],
});
